import $ from 'jquery';

var numberOfOpenModals = 0;
var baseZIndex = 1000;
var backdropIncrement = 100;
var modalIncrement = 50;

export function initModalLayeringManager(){
    
  $( "body" ).on("show.bs.modal", function(e){
      
      numberOfOpenModals++;    
      
      /**
       * The backdrop doesn't exist until after the show event
       * but it's too late by the shown event. By setTimeouting 
       * here we ensure that this code gets pushed to the next
       * frame and the backdrop exists.  
       */    
      setTimeout( function(){

        /**
         * get all the backdrops in the page
         */
        var backdrops = $(".modal-backdrop");        
        
        /**
         * calculate the backdrop z index by multiplying the num
         * of open modals by the 
         */      
        var newBackDropZIndex = baseZIndex + ( backdropIncrement * ( numberOfOpenModals ) );
        
        /**
         * Set the backdrop z index
         */
        $( backdrops[ numberOfOpenModals - 1 ] ).css( "z-index", newBackDropZIndex );
        
        /**
         * Set the modal z-index
         */
        $( e.target ).css( "z-index", newBackDropZIndex + modalIncrement );
      
      }, 0);
  });
  
  $( "body" ).on("hide.bs.modal", function(e){      
      numberOfOpenModals--;      
  });
    
}

var modalLeaveEvents = {};

export function addModalLeaveWarning( pageIdentifier, modalId, successCallback = null ){
    
  var modalSelector = "#" + modalId;
  var $modal = $( modalSelector );
  
  clearModalLeaveWarning( pageIdentifier, modalId );
  
  var modalLeaveFunction = function(event, extraParameters){
    
    event.preventDefault();
    
    
    $( "#tabSaveChangesWarningModal" ).modal( 'show' );
    
    $( "#tabSaveChangesWarningModal" ).find( "#tabSaveChangesWarningModalCancel" ).off( "click");
    $( "#tabSaveChangesWarningModal" ).find( "#tabSaveChangesWarningModalSubmit" ).off( "click");
    
    $( "#tabSaveChangesWarningModal" ).find( "#tabSaveChangesWarningModalCancel" ).on( "click", function(){
        $( "#tabSaveChangesWarningModal" ).modal( 'hide' );
    });
    
    $( "#tabSaveChangesWarningModal" ).find( "#tabSaveChangesWarningModalSubmit" ).on( "click", function(){
        var hideFunction = function(){
            $( "#tabSaveChangesWarningModal" ).off( 'hidden.bs.modal', hideFunction );
            clearModalLeaveWarning( pageIdentifier, modalId );
            if ( successCallback != null ){
              successCallback();
            }
            $modal.modal( 'hide' );  
        }
        $( "#tabSaveChangesWarningModal" ).on( 'hidden.bs.modal', hideFunction );
        $( "#tabSaveChangesWarningModal" ).modal( 'hide' );
        
    });
    
    return false;
  };
  
  $modal.on( "hide.bs.modal", modalLeaveFunction );    
  
  if ( typeof modalLeaveEvents[ pageIdentifier ] === "undefined" ){
    modalLeaveEvents[ pageIdentifier ] = {};
  }
  
  modalLeaveEvents[ pageIdentifier ][ modalId ] = modalLeaveFunction;

}

export function clearModalLeaveWarning( pageIdentifier, modalId ){
  
  var modalSelector = "#" + modalId;
  var $modal = $( modalSelector );
  
  if ( typeof modalLeaveEvents[ pageIdentifier ] !== "undefined" ){
      if ( typeof modalLeaveEvents[ pageIdentifier ][ modalId ] !== "undefined" ){
        $modal.off( 'hide.bs.modal', modalLeaveEvents[ pageIdentifier ][ modalId ] );
        delete modalLeaveEvents[ pageIdentifier ][ modalId ];
      }      
  }
}